import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSofa: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSofa"><Path d="M3 10V4H21V10H17.5V12.5H6.5V10H3Z" fill="currentColor"/><Path d="M1 11.5V18H4V20H5.5V18H18.5V20H20V18H23V11.5H19V14H5V11.5H1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSofa;
